// Detached image preloads do not emit errors through the window event listener.
type Listener = (source: string) => boolean | void;
const listeners = new Set<Listener>();

/** A true result means scoped routing was stopped and will restore the source. */
export function reportImageLoadError(source: string): boolean {
    let handled = false;
    for (const listener of [...listeners]) {
        if (listener(source) === true) handled = true;
    }
    return handled;
}

export function subscribeImageLoadErrors(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
